module.exports = __webpack_public_path__ + "img/km.0e09a290.png";